export const ROUTE = {
  PUBLIC_UPLOAD: '/pro/public-upload/',
  PRO_COMPLETE: '/pro/complete/',
  CAST_COMPLETE: '/cast/complete/'
} as const;

export const PUBLIC_ROUTES = [
  ROUTE.PUBLIC_UPLOAD,
] as const;
